import styled from '@emotion/styled';
import { captionSb } from '@teamsparta/stack-font';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  background: #1f1837;
`;

export const Title = styled.div`
  color: #36e496;
  text-align: center;
  font-family: Pretendard;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.22px;

  ${DESKTOP} {
    font-size: 24px;
  }
`;

export const HeroContentWrapper = styled.section`
  margin-top: 50px;
  display: flex;
  padding: 30px 16px 0px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  background: #1f1837;

  ${DESKTOP} {
    width: 100%;
    max-width: 100%;
  }
`;
export const HeroLogoTitle = styled.span`
  ${captionSb};
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
`;

export const Period = styled.div`
  display: flex;
  padding: 6px 20px;
  justify-content: center;
  align-items: center;
  gap: 9px;
  border-radius: 90px;
  background: #07735c;
  ${captionSb}
  color: #fff;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 600/294;
  max-width: 600px;
  margin: 0 auto;

  img {
    object-fit: contain;
    width: 100%;
    position: relative !important;
    height: unset !important;
  }
`;

export const DesktopImageWrapper = styled.div`
  position: relative;
  width: 500px;
  padding-top: 0.1px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 79px;
  object-fit: cover;
  height: 299px;
  margin: 0 auto;
`;
